import { Link } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { Accent, SectionHeading } from '../components/SectionHeading';
import { roles } from '../content/experience';

export function Timeline() {
  const highlights = roles.filter((role) => role.highlight);

  return (
    <section className="px-6 py-24 sm:px-8">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <SectionHeading eyebrow="Experience">
            Where I&apos;ve <Accent>been</Accent>.
          </SectionHeading>
        </Reveal>

        {/* Indent lives on the <li> so each dot can offset from the rail, not from the text. */}
        <ol className="relative mt-14 space-y-10 border-l-2 border-dashed border-mint-200">
          {highlights.map((role, index) => (
            <Reveal
              key={`${role.employer}-${role.period}`}
              delay={index * 100}
              as="li"
              className="relative pl-8 sm:pl-10"
            >
              <span
                aria-hidden="true"
                className="absolute -left-[9px] mt-2 h-4 w-4 rounded-full border-4 border-cream bg-mint-400"
              />
              <p className="font-display text-sm font-semibold tracking-wide text-blush-500">
                {role.period}
              </p>
              <h3 className="mt-1 text-xl">{role.title}</h3>
              <p className="mt-0.5 text-sm text-muted">
                {role.employer} · {role.location}
              </p>
              <p className="mt-3 leading-relaxed">{role.bullets[0]}</p>
            </Reveal>
          ))}
        </ol>

        <Reveal delay={120}>
          <p className="mt-12 text-center">
            <Link
              to="/resume"
              className="font-display font-semibold text-mint-700 underline decoration-mint-300 decoration-2 underline-offset-4 transition-colors hover:text-mint-900 hover:decoration-mint-500"
            >
              See the full resumé →
            </Link>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
